import { Box, VStack, Text, Button, Heading, Flex, Badge, Divider, Skeleton, Stack, Alert, AlertIcon } from '@chakra-ui/react'
import { BsCheckCircleFill, BsBoxSeam } from 'react-icons/bs'

export function ConfirmationCard({ itemData, isItemLoading, loading, onConfirm, formatDate }) {
  if (isItemLoading) {
    return (
      <Box bg="#3a4a53" p={6} borderRadius="xl" shadow="md" w="100%">
        <Stack spacing={4}>
          <Skeleton height="30px" />
          <Skeleton height="20px" />
          <Skeleton height="20px" />
          <Divider borderColor="whiteAlpha.300" />
          <Skeleton height="20px" />
          <Skeleton height="20px" />
          <Skeleton height="20px" />
          <Skeleton height="20px" />
          <Skeleton height="50px" />
        </Stack>
      </Box>
    )
  }
  if (!itemData || !itemData.itens || itemData.itens.length === 0) {
    return (
      <Box bg="#3a4a53" p={6} borderRadius="xl" shadow="md" w="100%">
        <Alert status="warning" borderRadius="md" bg="#4a5a64" color="white">
          <AlertIcon color="#f0ad4e" />
          Selecione um item para visualizar os detalhes
        </Alert>
      </Box>
    )
  }

  const item = itemData.itens[0]

  return (
    <Box bg="#3a4a53" p={6} borderRadius="xl" shadow="md" w="100%">
      <VStack spacing={6} align="stretch">
        <Flex align="center" justify="center" direction="column">
          <Box fontSize="4xl" color="#37F091" mb={2}>
            <BsBoxSeam />
          </Box>
          <Heading size="md" color="white" textAlign="center">
            Confirmar Recebimento de Troca
          </Heading>
          <Text color="whiteAlpha.800" textAlign="center" mt={2} fontSize="sm">
            Confirme o recebimento do item devolvido pelo cliente
          </Text>
        </Flex>

        <Divider borderColor="whiteAlpha.300" />

        <Box>
          <Heading size="sm" color="#37F091" mb={3}>
            Detalhes do Item
          </Heading>

          <Flex justify="space-between" mb={2}>
            <Text color="whiteAlpha.800">Produto:</Text>
            <Text color="white" fontWeight="medium">
              {item.descricao || item.descricao_produto}
            </Text>
          </Flex>

          <Flex justify="space-between" mb={2}>
            <Text color="whiteAlpha.800">Código:</Text>
            <Text color="white">{item.codigo_produto}</Text>
          </Flex>

          <Flex justify="space-between" mb={2}>
            <Text color="whiteAlpha.800">Quantidade:</Text>
            <Text color="white">{item.quantidade}</Text>
          </Flex>

          <Flex justify="space-between" mb={2}>
            <Text color="whiteAlpha.800">Sequência:</Text>
            <Text color="white">{item.sequencia}</Text>
          </Flex>

          {item.data_usuario_troca && (
            <Flex justify="space-between" mb={2}>
              <Text color="whiteAlpha.800">Troca solicitada em:</Text>
              <Text color="white">{formatDate(item.data_usuario_troca)}</Text>
            </Flex>
          )}

          <Flex justify="space-between">
            <Text color="whiteAlpha.800">Status:</Text>
            <Badge colorScheme="orange">{item.passo_atual}</Badge>
          </Flex>
        </Box>

        <Divider borderColor="whiteAlpha.300" />

        <Box>
          <Heading size="sm" color="#37F091" mb={3}>
            Informações do Pedido
          </Heading>

          <Flex justify="space-between" mb={2}>
            <Text color="whiteAlpha.800">Número da Nota:</Text>
            <Text color="white">{itemData.numero_nota}</Text>
          </Flex>

          <Flex justify="space-between" mb={2}>
            <Text color="whiteAlpha.800">Cliente:</Text>
            <Text color="white">{itemData.nome_cliente}</Text>
          </Flex>

          <Flex justify="space-between">
            <Text color="whiteAlpha.800">Data do Pedido:</Text>
            <Text color="white">{formatDate(itemData.data_pedido)}</Text>
          </Flex>
        </Box>

        <Button
          leftIcon={<BsCheckCircleFill />}
          colorScheme="green"
          bg="#37F091"
          color="#313E44"
          size="lg"
          onClick={onConfirm}
          isLoading={loading}
          loadingText="Confirmando recebimento..."
          _hover={{ bg: '#2cda7e' }}
        >
          Confirmar Recebimento
        </Button>

        <Text fontSize="sm" color="whiteAlpha.700" textAlign="center">
          Ao confirmar o recebimento, o status deste item será atualizado para "Troca Recebida".
        </Text>
      </VStack>
    </Box>
  )
}
